import { Search } from 'lucide-react'

interface Props {
  query: string
  status: string
  onQueryChange: (value: string) => void
  onStatusChange: (value: string) => void
  disabled?: boolean
}

const STATUS_OPTIONS = [
  { value: 'all', label: 'Todas' },
  { value: 'enabled', label: 'Ativas' },
  { value: 'disabled', label: 'Desativadas' },
]

export default function IntegrationFilters({ query, status, onQueryChange, onStatusChange, disabled = false }: Props) {
  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-center">
      <div className="relative md:w-80">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <input
          type="text"
          value={query}
          onChange={(event) => onQueryChange(event.target.value)}
          disabled={disabled}
          placeholder="Buscar por nome, slug ou descrição"
          aria-label="Buscar integrações"
          className="h-9 w-full rounded-md border border-border bg-background py-2 pl-9 pr-3 text-sm text-foreground outline-none focus:ring-2 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-60"
        />
      </div>

      <div className="flex rounded-md border border-border bg-background p-1" role="group" aria-label="Status">
        {STATUS_OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            aria-pressed={status === option.value}
            disabled={disabled}
            onClick={() => onStatusChange(option.value)}
            className={`h-7 rounded px-3 text-sm transition-colors disabled:cursor-not-allowed disabled:opacity-60 ${
              status === option.value
                ? 'bg-accent text-accent-foreground'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  )
}
